import * as React from 'react'
import ApiService from "@bodeboca/api"
import {useTranslation} from "react-i18next"

const ProductRanking = ({
  hit
}) => {
  const ranking = ApiService.getRankingObject()
  const {t} = useTranslation()
  return (
    <>
      { !ApiService.isContext('search') && ranking !== undefined && hit['rankings'] !== undefined &&
        <div className="wineblock-topten">
          Nº {hit['rankings'][ranking['id']]} {t(ranking['label'])}
        </div>}
    </>)
}
export default ProductRanking
